export function useVipFeature({ autoLoad } = { autoLoad: true }) {
  const { vipClubEnabled } = useRuntimeConfig().public;
  const store = shallowRef<ReturnType<(typeof import('~/store/vip'))['useVipStore']> | null>(null);

  async function load(): Promise<typeof store.value> {
    if (!vipClubEnabled) return null;
    if (store.value) return store.value;

    const { useVipStore } = await import('~/store/vip');

    if (typeof useVipStore === 'function') {
      store.value = useVipStore();
    }

    return store.value;
  }

  if (autoLoad) {
    load();
  }

  return { store, load };
}
